<script>
import {userPortraitOptions} from "@/api/login";

export default {
  props:['workform'],
  data() {
    return {
      dialogVisible: true,
      form:{
        start_time:'',//工作时间
        end_time:'',//工作时间
        title:'',//公司名
        location:'',//所在地
        trade:'',//行业
        start_job:'',//起始岗位
        end_job:'',//最终岗位
        time:[]
      },
      JobList:[],
      CompanyList:[]
    };
  },
  mounted() {
    userPortraitOptions().then(res=>{
      if(res.code === 200){
        this.JobList =  res.data.find(item => item.title === '岗位类别').value;
        this.CompanyList =  res.data.find(item => item.title === '公司行业').value;
      }
    })

    if(this.workform){
     this.form = this.workform
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    handleSave(){
      if (Array.isArray(this.form.time) && this.form.time.length === 0) {
        this.$message.error('工作时间不能为空');
        return;
      }
      if(!this.form.title){
        this.$message.error('公司名称不能为空')
        return
      }
      this.form.start_time = this.form.time[0]
      this.form.end_time = this.form.time[1]

      this.$emit('save',this.form)
    }
  }
}
</script>

<template>
  <el-dialog
      title="添加工作经历"
      :visible.sync="dialogVisible"
      width="480px"
      class="ljl-re-add"
      :before-close="handleClose">
    <div class="add-re-form">
      <div class="add-re-form-item">
        <div class="add-re-form-item-title"><span class="add-re-form-item-red">*</span>工作时间</div>
        <el-date-picker
            v-model="form.time"
            size="small"
            class="ljl-re-add-time"
            style="width: 100% !important;"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <div class="add-re-form-item">
        <div class="add-re-form-item-title"><span class="add-re-form-item-red">*</span>公司名称</div>
        <el-input v-model="form.title" clearable size="small" placeholder="请输入公司名称"></el-input>
      </div>
      <div class="add-re-form-item">
        <div class="add-re-form-item-title"><span class="add-re-form-item-red"></span>公司所在地</div>
        <el-input v-model="form.location" clearable size="small" placeholder="请输入公司所在地"></el-input>
      </div>
      <div class="add-re-form-item">
        <div class="add-re-form-item-title"><span class="add-re-form-item-red"></span>公司行业</div>
        <el-select v-model="form.trade" clearable size="small" style="width: 100%!important;" placeholder="请选择公司行业">
          <el-option v-for="(item,index) in CompanyList" :key="index" :label="item.value" :value="item.id"></el-option>
        </el-select>
      </div>
      <div class="add-re-form-item">
        <div class="add-re-form-item-title"><span class="add-re-form-item-red"></span>起始岗位</div>
        <el-input v-model="form.start_job" clearable size="small" placeholder="请输入起始岗位"></el-input>
      </div>
      <div class="add-re-form-item">
        <div class="add-re-form-item-title"><span class="add-re-form-item-red"></span>最终岗位</div>
        <el-input v-model="form.end_job" clearable size="small" placeholder="请输入最终岗位"></el-input>
      </div>
    </div>
    <span slot="footer" class="add-footer">
    <div class="add-footer-but cols" @click="handleClose">取消</div>
    <div class="add-footer-but conf" @click="handleSave">确定</div>
  </span>
  </el-dialog>
</template>

<style scoped lang="scss">
.add-re-form{
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  .add-re-form-item{
    display: flex;
    align-items: center;
    column-gap: 20px;
    .add-re-form-item-title{
      flex: 0 0 auto;
      width: 70px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-family: Microsoft YaHei UI, Microsoft YaHei UI;
      font-weight: 400;
      font-size: 14px;
      color: #60656E;
      line-height: 16px;
      word-break: keep-all;
      white-space: nowrap;
      .add-re-form-item-red{
        color: #F74B4B;
      }
    }
  }
}
.add-footer{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 12px;
  .add-footer-but{
    height: 32px;
    box-sizing: border-box;
    padding: 0 24px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Microsoft YaHei UI, Microsoft YaHei UI;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    cursor: pointer;
  }
  .cols{
    border: 1px solid #DCDFE6;
    color: #60656E;
  }
  .cols:hover{
    border: 1px solid #1D78FE;
    color: #1D78FE;
  }
  .conf{
    border: 1px solid #1A6BFF;
    background: #1A6BFF;
    color: white;
  }
  .conf:hover{
    border: 1px solid #1D78FE;
    background: #1D78FE;
  }
}
</style>
<style>
.ljl-re-add .el-dialog__header{
  border-bottom: 1px #F0F1F5 solid;
  padding: 20px 20px 10px 30px;
}
.ljl-re-add .el-dialog__body{
  padding: 20px 36px 24px 36px !important;
}
.ljl-re-add .el-dialog__footer{
  padding: 0 30px 26px 30px !important;
}
.ljl-re-add-time .el-range-separator{
  line-height: 32px !important;
}
.ljl-re-add-time .el-range__close-icon{
  line-height: 32px !important;
}
.ljl-re-add-time .el-range__icon{
  line-height: 32px !important;
}
.ljl-re-add-time .el-range-input{
  font-size: 14px !important;
}

</style>
